import { UniformButton } from "../src/button.tsx";
export type { UniformButtonProps } from "../src/button.tsx";

export default UniformButton;
